import Hackathon from '@/models/Hackathon';
import { Project } from '@/models/Project';
import User from '@/models/User';
import Permission, { PermissionParams } from './Permission';

interface IPermissionParams extends PermissionParams<Project> {
  user?: User;
  hackathon?: Hackathon;
  isLoadingHackathon?: boolean;
  isLeiFelca?: boolean;
}

export default class ProjectPermissions extends Permission<Project> {
  hackathon?: Hackathon;
  isLoadingHackathon?: boolean;
  isLeiFelca?: boolean;

  constructor({
    hackathon,
    user,
    model,
    isLoadingHackathon,
    isLeiFelca,
  }: IPermissionParams) {
    super({ user, model });
    this.hackathon = hackathon;
    this.isLoadingHackathon = isLoadingHackathon;
    this.isLeiFelca = isLeiFelca;
  }

  isUserOwnerOfProject(): boolean {
    if (!this.model || !this.user) return false;

    return (
      this.model.users.some(projectUser => projectUser.id === this.user?.id) ||
      this.isMentor()
    );
  }

  isMentor(): boolean {
    if (!this.model || !this.user) return false;
    return this.user.id === this.model.teacherMentor?.id;
  }

  isProjectHackathon(): boolean {
    if (!this.model || !this.hackathon) return false;
    return (
      this.model.flags?.some(flag => flag.id === this.hackathon?.flagId) ||
      false
    );
  }

  canInteract(): boolean {
    if (this.hasSuperPrivileges()) return true;
    return !this.isLoadingHackathon && !this.isProjectHackathon();
  }

  canManage(): boolean {
    const isMentor = this.isMentor();
    const isSuper = this.hasSuperPrivileges();
    const isProjectHackathon = this.isProjectHackathon();
    const isUserOwner = this.isUserOwnerOfProject();
    if (this.isLeiFelca) {
      return isMentor || isSuper;
    }

    return isMentor || isSuper || (isUserOwner && !isProjectHackathon);
  }
}
